import React, { useState } from 'react'
import Grid from '@mui/material/Grid2'
import MaterialBox from '../../../../../../components/MaterialBox'
import MaterialTypography from '../../../../../../components/MaterialTypography'
import MaterialInput from '../../../../../../components/MaterialInput'
import { FormControl, FormHelperText, Icon } from '@mui/material'
import MaterialLoadingButton from '../../../../../../components/MaterialLoadingButton'
import CheckIcon from '@mui/icons-material/Check';
import {useUserDetails} from '../../../../../../context/auth'
const PFDetails = ({
    employeeData,
    handleEmployeeDataChange,
    handleBankDetailsVerification,
    togglePage
}) => {

    const {validation,validationMessages} = useUserDetails()

    const [ifscButtonStatus, setIfscButtonStatus] = useState('unverified')
    const [ifscDetails, setIfscDetails] = useState({
        bankName: 'IOB',
        branchName: 'Tirupur branch'
    })
    const [panButtonStatus, setPanButtonStatus] = useState('unverified')
    const [aadharButtonStatus, setAadharButtonStatus] = useState('unverified')

    const handleIFSCVerification = async () => {
        setIfscButtonStatus('verifying')
        setTimeout(() => { getIfscData() }, 3000);
    }
    const getIfscData = () => {
        setIfscButtonStatus('verified')
        handleBankDetailsVerification(true, 'Ifsc')
    }
    const handlePANVerification = async () => {
        setPanButtonStatus('verifying')
    }

    const handleAadharVerification = async () => {
        setAadharButtonStatus('verifying')

    }

    return (
        <MaterialBox>
            <MaterialTypography variant="h5">Banking info</MaterialTypography>
            <Grid container spacing={1}>
            <Grid item size={{ xs: 12, sm: 4, lg: 4 }} >
                    <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                        >
                            Account Number 
                        </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput type="text" placeholder="eg.123456789"
                        name="accountnumber"
                        value={employeeData.accountnumber}
                        onChange={handleEmployeeDataChange}
                        error={employeeData.accountnumberStatus === "error" ? true : false}
                        success={employeeData.accountnumberStatus === "success" ? true : false}
                        // disabled={(ifscButtonStatus === 'verified' || ifscButtonStatus === 'verifying') ? true : false}
                        disabled={togglePage.view === true ? true : false}
                    />
                     {employeeData.accountnumberStatus ==='error' && (
                   <FormControl error>
                   <FormHelperText>
                   Should accept only numbers maximum 25 digits
                   </FormHelperText>
                 </FormControl>
                )}
                 {validationMessages.accountnumber && (
    <label style={{ color: "red", fontSize: "12px" }}>
      {validationMessages.accountnumber}
    </label>
  )}
                    </Grid>
                    <Grid item size={{ xs: 12, sm: 4, lg: 4 }} >
                    <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                        >
                           Bank Name 
                        </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput type="text" placeholder="eg.ABCD"
                        name="bankname"
                        value={employeeData.bankname}
                        onChange={handleEmployeeDataChange}
                        error={employeeData.banknameStatus === "error" ? true : false}
                        success={employeeData.banknameStatus === "success" ? true : false}
                        // disabled={(ifscButtonStatus === 'verified' || ifscButtonStatus === 'verifying') ? true : false}
                        disabled={togglePage.view === true ? true : false}
                       
                    />
                      {employeeData.banknameStatus ==='error' && (
                   <FormControl error>
                   <FormHelperText>
                   Should accept only Text Fields maximum of 25 Characters.
                   </FormHelperText>
                 </FormControl>
                )}
                     {validationMessages.bankname && (
                    <label style={{ color: "red", fontSize: "12px" }}>
                    {validationMessages.bankname}
                    </label>
                )}
                    </Grid>
                <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
                    <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                        >
                            Enter IFSC 
                        </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput type="text" placeholder="eg.ABCD0000128"
                        name="enterIfsc"
                        value={employeeData.enterIfsc}
                        onChange={handleEmployeeDataChange}
                        error={employeeData.enterIfscStatus === "error" ? true : false}
                        success={employeeData.enterIfscStatus === "success" ? true : false}
                        // disabled={(ifscButtonStatus === 'verified' || ifscButtonStatus === 'verifying') ? true : false}
                        disabled={togglePage.view === true ? true : false}
                    />
                    {
                        employeeData.enterIfscStatus === "error" ?
                            <FormControl error>
                                <FormHelperText>
                                    Please enter a valid IFSC code Eg:HDFC0000189
                                </FormHelperText>
                            </FormControl>
                            :
                            null
                    }
                    {
                        employeeData.isIfscVerifyStatus === "success" && (
                            <FormControl >
                                <FormHelperText>
                                    <MaterialTypography variant="caption" fontWeight="bold" color="success" style={{
                                        display: "flex",
                                        alignItems: "center"
                                    }}>
                                        <CheckIcon />&nbsp;
                                        Verified
                                        <MaterialTypography variant="caption" fontWeight="bold" color="success" ml={2} >
                                            {ifscDetails?.bankName}, {ifscDetails?.branchName}
                                        </MaterialTypography>
                                    </MaterialTypography>

                                </FormHelperText>
                            </FormControl>
                        )
                    }
                       {validationMessages.enterIfsc && (
                    <label style={{ color: "red", fontSize: "12px" }}>
                    {validationMessages.enterIfsc}
                    </label>
                )}
                </Grid>
                {/* <Grid item mt={4} >
                    {
                        ((ifscButtonStatus === 'unverified' || ifscButtonStatus === 'verifying') && employeeData.isIfscVerifyStatus !== "success") &&
                        <MaterialLoadingButton
                            onClick={handleIFSCVerification}
                            loading={ifscButtonStatus === "verifying" ? true : false}
                            loadingIndicator="Verifying…"
                            variant="outlined"
                            color="success"
                            sx={{ color: "#39B54A", backgroundcolor: "#39B54A" }}
                            disabled={(aadharButtonStatus === "verifying" || ifscButtonStatus === "verifying" || panButtonStatus === "verifying") ? true : employeeData.enterIfscStatus === "success" ? false : true}
                        >
                            Verify
                        </MaterialLoadingButton>
                    }
                </Grid> */}

                <Grid item size={{ xs: 12, sm: 4, lg: 4 }} >
                    <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                        >
                            CIF Number 
                        </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput type="text" placeholder="eg.123456789"
                        name="cifnumber"
                        value={employeeData.cifnumber}
                        onChange={handleEmployeeDataChange}
                        error={employeeData.cifnumberStatus === "error" ? true : false}
                        success={employeeData.cifnumberStatus === "success" ? true : false}
                        // disabled={(ifscButtonStatus === 'verified' || ifscButtonStatus === 'verifying') ? true : false}
                        disabled={togglePage.view === true ? true : false}
                    />
                     {employeeData.cifnumberStatus ==='error' && (
                   <FormControl error>
                   <FormHelperText>
                   Should accept only numbers maximum 25 digits
                  </FormHelperText>
                 </FormControl>
                )}
                     {validationMessages.cifnumber && (
                    <label style={{ color: "red", fontSize: "12px" }}>
                    {validationMessages.cifnumber}
                    </label>
                )}
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 4, lg: 4 }} >
                    <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                        >
                           Branch Name 
                        </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput type="text" placeholder="eg.CHENNAI"
                        name="branchname"
                        value={employeeData.branchname}
                        onChange={handleEmployeeDataChange}
                        error={employeeData.branchnameStatus === "error" ? true : false}
                        success={employeeData.branchnameStatus === "success" ? true : false}
                        // disabled={(ifscButtonStatus === 'verified' || ifscButtonStatus === 'verifying') ? true : false}
                        disabled={togglePage.view === true ? true : false}
                    />
                     {employeeData.branchnameStatus ==='error' && (
                   <FormControl error>
                   <FormHelperText>
                   Should accept only Text Fields maximum of 25 Characters.
                  </FormHelperText>
                 </FormControl>
                )}
                      {validationMessages.branchname && (
                    <label style={{ color: "red", fontSize: "12px" }}>
                    {validationMessages.branchname}
                    </label>
                )}
                    </Grid>
            </Grid>
        </MaterialBox>
    )
}

export default PFDetails
